import React from 'react';
import { InnerLayout, PillNavItem } from '../components/layout/InnerLayout';
import { FolderKanban, Shield, Trash2 } from 'lucide-react';
import { useProjectSettings } from './settings/hooks/useProjectSettings';
import { ProjectGeneralCard } from './settings/components/ProjectGeneralCard';
import { ProjectIngressCard } from './settings/components/ProjectIngressCard';
import { ProjectDangerCard } from './settings/components/ProjectDangerCard';

export const SettingsView: React.FC = () => {
  const {
    currentOrg,
    currentProject,
    canAdmin,
    canDeleteProject,
    activeTab,
    setActiveTab,
    projectName,
    setProjectName,
    projectDesc,
    setProjectDesc,
    isSavingGeneral,
    handleSaveGeneral,
    origins,
    setOrigins,
    redirects,
    setRedirects,
    rateLimit,
    setRateLimit,
    isSavingIngress,
    handleSaveIngress,
    copiedProjectId,
    copyProjectId,
    deleteModalOpen,
    setDeleteModalOpen,
    deleteConfirmText,
    setDeleteConfirmText,
    isDeleting,
    handleDeleteProject,
  } = useProjectSettings();

  const navItems: PillNavItem[] = [
    {
      id: 'general',
      label: 'General & API Keys',
      icon: FolderKanban,
      active: activeTab === 'general',
      onClick: () => setActiveTab('general'),
    },
    {
      id: 'ingress',
      label: 'Ingress & Security',
      icon: Shield,
      active: activeTab === 'ingress',
      onClick: () => setActiveTab('ingress'),
    },
    ...(canDeleteProject
      ? [
          {
            id: 'danger',
            label: 'Danger Zone',
            icon: Trash2,
            danger: true,
            active: activeTab === 'danger',
            onClick: () => setActiveTab('danger'),
          },
        ]
      : []),
  ];

  return (
    <InnerLayout
      header={{
        title: `Project Settings: ${currentProject?.name || 'Project'}`,
        description:
          'Manage ingress domain boundaries, allowed CORS origins, rate limits, and API credentials for this specific project.',
      }}
      navItems={navItems}
    >
      {activeTab === 'general' && (
        <ProjectGeneralCard
          currentProject={currentProject}
          currentOrg={currentOrg}
          canAdmin={canAdmin}
          projectName={projectName}
          setProjectName={setProjectName}
          projectDesc={projectDesc}
          setProjectDesc={setProjectDesc}
          isSavingGeneral={isSavingGeneral}
          handleSaveGeneral={handleSaveGeneral}
          copiedProjectId={copiedProjectId}
          copyProjectId={copyProjectId}
        />
      )}

      {activeTab === 'ingress' && (
        <ProjectIngressCard
          canAdmin={canAdmin}
          origins={origins}
          setOrigins={setOrigins}
          redirects={redirects}
          setRedirects={setRedirects}
          rateLimit={rateLimit}
          setRateLimit={setRateLimit}
          isSavingIngress={isSavingIngress}
          handleSaveIngress={handleSaveIngress}
        />
      )}

      {canDeleteProject && activeTab === 'danger' && (
        <ProjectDangerCard
          currentProject={currentProject}
          deleteModalOpen={deleteModalOpen}
          setDeleteModalOpen={setDeleteModalOpen}
          deleteConfirmText={deleteConfirmText}
          setDeleteConfirmText={setDeleteConfirmText}
          isDeleting={isDeleting}
          handleDeleteProject={handleDeleteProject}
        />
      )}
    </InnerLayout>
  );
};
